export default function SingleCareer() {
	return <div>SingleCareer</div>;
}
